import React, { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

const PageNotFound = () => {
  const location = useLocation();
  const navigate = useNavigate()
  const URL = location.pathname.split(';id=')
  console.log(URL)

  useEffect(() => {
    if (URL[0] === '/blogpost') {
      console.log(URL[1])
      window.location.href = `https://www.blog.causalfunnel.com/blogpost;id=${URL[1]}`
    } else {
      navigate("/");
    }
  }, [])
  return (
    <div></div>
  )
}

export default PageNotFound